import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { convertObjectToLowerCamelCase } from '../utility/utility';

@Injectable({ providedIn: 'root' })
export class AccountService {
  account$: Observable<any>;
  private accountSubject = new Subject<any>();
  private _accountInfo: any | null = null;

  constructor(private router: Router) {
    this.account$ = this.accountSubject.asObservable();
  }

  /**
   * アカウント情報
   */
  set accountInfo(v: any) {
    const lowerCamelAccount = convertObjectToLowerCamelCase(v);
    this._accountInfo = lowerCamelAccount;
    this.accountSubject.next(lowerCamelAccount);
  }

  /**
   * アカウント情報
   * TODO: 🚨 複数の場合の選択方法
   */
  get accountInfo(): any | null {
    return this._accountInfo;
  }

  /**
   * ユーザー名
   * {FamilyName} + {FirstName}
   */
  get userName(): string {
    return `${this._accountInfo.familyName} ${this._accountInfo.firstName}`;
  }

  /** ログアウト */
  logout(): void {
    this.accountSubject.next(null);
  }
}
